<template>
    <div style="text-align:center;">
        <el-tree :data="treeOptions"
                 default-expand-all
                 node-key="id"
                 ref="treejson"
                 highlight-current
                 show-checkbox
                 :props="defaultTreeProps"
                 :default-checked-keys="defaulttreecheckedKeys">
        </el-tree>
        <el-button @click="updateTreeJsonSubmit" type="primary" style="margin-top:30px;">更新权限</el-button>
    </div>
</template>

<script>
    import { updateEntity } from '@/api/utils';

    export default {
        name: 'Treejson',
        components: {
        },
        props: {
            Id: {
                type: String
            },
            treeJsonData: {
                type: Array
            }
        },
        data() {
            return {
                defaultTreeProps: {
                    children: 'children',
                    label: 'label'
                },
                defaulttreecheckedKeys: [],
                treecheckedKeys: []
            }
        },
        computed: {
            treeOptions() {
                //根据treeJsonData计算treeOpitons      
                return this.createTreeOptionsbyArr(this, this.treeJsonData);
            }
        },
        methods: {
            closeTreeJson() {
                this.$emit('close', false);
            },
            createTreeJsonData(ob, arr) {
                //遍历当前treejsondata,一旦path在checkedkeys里面,则enable为true,否则为false
                arr.forEach((item, index, arr) => {
                    arr[index].enable = (ob.treecheckedKeys.indexOf(arr[index].path) > -1);
                    if (arr[index].children && arr[index].children.length > 0)
                        ob.createTreeJsonData(ob, arr[index].children);
                });
            },
            createTreeOptionsbyArr(ob, arr) {
                if (arr && arr.length>0)
                    return arr.map(function(item){
                    let newitem = {
                        id: item.path,
                        label: item.title
                    };
                    if (item.children && item.children.length > 0)
                        newitem.children = ob.createTreeOptionsbyArr(ob, item.children);
                    else if (item.enable) ob.defaulttreecheckedKeys.push(newitem.id);
                    return newitem;
                    });
                return [];
            },
            async updateTreeJsonSubmit() {
                this.treecheckedKeys = this.$refs.treejson.getCheckedKeys().concat(this.$refs.treejson.getHalfCheckedKeys());
                var newTreeJsonData = JSON.parse(JSON.stringify(this.treeJsonData));
                this.createTreeJsonData(this, newTreeJsonData);
                var postFormData = {
                    Id:this.Id,
                    Menu: JSON.stringify(newTreeJsonData)
                };
                let res = await updateEntity('UserType', [postFormData]).catch(() => { });
                if (res != null && res.Code == 1) {
                    this.$message({
                        message: "配置权限成功",
                        type: 'success'
                    });
                    this.$emit('change', { name: 'treejson', params: postFormData.Menu });
                    this.closeTreeJson();
                } else {
                    this.$message.error("配置权限失败");
                }
            }
        }
    }
</script>

<style scoped>
</style>